export class RootElementNotFoundError extends Error {
  constructor(public readonly elementId: string) {
    super(`Failed to find the root element with id "${elementId}"`);
    this.name = "RootElementNotFoundError";
  }
}
